import React from "react";
import { Link } from "react-router-dom";
import { Message, Icon } from "semantic-ui-react";
import PrimaryButton from "../../../components/Button/PrimaryButton";
import { FormattedMessage } from "react-intl";
import styles from "./NoProfile.module.scss";

const NoProfile = () => {
  return (
    <div className={styles.container}>
      <Message icon info size="large">
        <Icon name="user circle" />
        <Message.Content>
          <Message.Header>
            <FormattedMessage
              id="dashboard.noProfile.title"
              defaultMessage="Welcome! Let's Get Started"
            />
          </Message.Header>
          <p>
            <FormattedMessage
              id="dashboard.noProfile.message"
              defaultMessage="You haven't set up your designer profile yet. Create your profile to start selling your amazing patterns and connect with customers around the world!"
            />
          </p>
          <Link to="/manage-profile" className={styles.buttonLink}>
            <PrimaryButton text={
              <FormattedMessage
                id="dashboard.noProfile.button"
                defaultMessage="Create Your Profile"
              />
            } />
          </Link>
        </Message.Content>
      </Message>
    </div>
  );
};

export default NoProfile;
